<template>
    <div v-if="show" class="spinner-wrapper fadeIn faster animated">
        <div class="lds-ring">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div>
</template>
 
<script>        
export default {
    data(){
        return{
            show:false
        }
    },
    methods:{
        startSpinner(){
            this.show = true;
        },
        stopSpinner(){
            this.show = false;
        },
        spinFor(time){
          this.startSpinner();
          setTimeout(this.stopSpinner,time);
        }
    }

}
</script>

<style scoped>
.spinner-wrapper{
    position: fixed;
    background-color: rgba(249, 246, 244, 0.7);
    top: 0;
    bottom: 0px;
    left: 0;
    right: 0;
    z-index: 1000;
    display: flex;
    justify-content: center;
    align-items: center;
}
.lds-ring {
  display: inline-block;
  position: relative;
  width: 64px;
  height: 64px;
  /* top: calc(50% - 64px);
  left: calc(50% - 64px); */
}
.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 51px;
  height: 51px;
  margin: 6px;
  /* border: 6px solid #fff; */
  border: 6px solid rgba(1, 97, 69, 1);
  border-radius: 50%;
  /* animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite; */
  animation: lds-ring 1.2s cubic-bezier(0.0, 0.0, 1.0, 1.0) infinite;
  animation-duration: 600ms;
  /* border-color: #fff transparent transparent transparent; */
  border-color: rgba(1, 97, 69, 1) transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
  animation-delay: -0.10s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// resources/js/components/partials/LoadingSpinner.vue